import styled from '@emotion/styled';
import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import { type HTMLArticleProps } from '@/lib/types';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type StyledCommentProps = HTMLArticleProps & {
  isInLogEntry: boolean;
};

const StyledComment = styled('article')<StyledCommentProps>(
  ({ theme }) => ({
    fontSize: 15,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
  }),
  ({ theme, isInLogEntry }) => {
    if (isInLogEntry) {
      return {
        padding: 12,
        marginBottom: 12,
        borderRadius: 4,
        ':first-of-type': {
          marginTop: 12,
        },
        ':last-of-type': {
          marginBottom: 0,
        },
      };
    }

    return {
      padding: 18,
      borderBottom: `2px solid ${theme.palette.divider}`,
      ':first-of-type': {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
      ':last-of-type': {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        borderBottom: theme.palette.isHighContrast ? undefined : 'none',
      },
    };
  },
  addBorderInHighContrastMode,
  addHighContrastStyles(({ isInLogEntry }) => {
    if (!isInLogEntry) {
      return {
        ':not(:last-of-type)': {
          borderBottom: 'none',
        },
      };
    }
  }),
  addHighContrastStyles(({ theme }) => {
    if (theme.isDark) {
      return {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      };
    }
  }),
);

export default StyledComment;
